// container elements
const feedbackFormContainer = document.querySelector('.feedback-form-container');
const feedbackForm = document.querySelector('.form-customer-service-form');
const alertDialog = document.querySelector('.customer-service-alert');
const infoText = document.querySelector('.hide-info-text');

// input elements
const orderNumberInput = document.querySelector('.order-number-input');

// button elements
const hideButton = document.querySelector('.hide-form-button');
const arrowDown = document.querySelector('.arrow-down');
const arrowUp = document.querySelector('.arrow-up');
const closeAlertButton = document.querySelector('.close-alert-button');

// radio button elements
const webstoreRadio = document.getElementById('webstore');
const intersportStoreRadio = document.getElementById('IntersportStore');
const emailRadio = document.getElementById('emailSelected');
const phoneRadio = document.getElementById('phoneSelected');

// select containers
const categorySelect = document.querySelector('.category-select');
const subcategorySelect = document.querySelector('.subcategory-select');
const teamSelect = document.querySelector('.team-select');
const shopSelect = document.querySelector('.shop-select');

// select element
const categoriesSelect = document.getElementsByName('category')?.[0];
const shopsSelect = document.getElementsByName('shop')?.[0];

// text elements
const contactInfoSpan = document.querySelector('.contactInfo-info');

const hideForm = () => {
	feedbackFormContainer.classList.add('hidden');
	arrowUp.classList.add('hidden');
	arrowDown.classList.remove('hidden');
	infoText.textContent = 'Näytä yhteydenottolomake';
}

const showForm = () => {
	feedbackFormContainer.classList.remove('hidden');
	arrowUp.classList.remove('hidden');
	arrowDown.classList.add('hidden');
	infoText.textContent= 'Piilota yhteydenottolomake';
}

const toggleFormVisibility = () => {
	const isHidden = feedbackFormContainer.classList.contains('hidden');

	if (isHidden) {
		showForm();
	} else {
		hideForm();
	}
}


const checkFormVisibility = () => {
	const isHidden = feedbackFormContainer.classList.contains('hidden');
	const width = window.innerWidth;

	if (width < 769 && isHidden) {
		showForm();
	}
}

const filterCategories = () => {
	const condition = webstoreRadio?.checked ? webstoreRadio.value : intersportStoreRadio?.checked ? intersportStoreRadio?.value : '';
	categoriesSelect.options[0].selected = 'selected';

	if (!subcategorySelect.classList.contains('hidden')) {
		subcategorySelect.classList.add('hidden');
	}
	if (!teamSelect.classList.contains('hidden')) {
		teamSelect.classList.add('hidden');
	}
	if (!shopSelect.classList.contains('hidden') && condition !== 'IntersportStore') {
		shopSelect.classList.add('hidden');
		shopsSelect.dataset.validation = '';

	} else if (shopSelect.classList.contains('hidden') && condition === 'IntersportStore') {
		shopSelect.classList.remove('hidden');
		shopsSelect.dataset.validation = 'required';
	}

	if (condition) {
		categorySelect.classList.remove('hidden');
		for (const option of categoriesSelect?.options) {
			const optionConditions = option.getAttribute('data-conditionalValues');

			if (option.classList.contains('hidden')) {
				option.classList.remove('hidden');
			}

			if (!optionConditions.includes(condition)) {
				option.classList.add('hidden');
			}

			if (option.value === 'a3' && condition === 'webstore') {
				option.innerHTML = 'Tilaus ja toimitus';
			}

			if (option.value === 'a3' && condition === 'IntersportStore') {
				option.innerHTML = 'Tilaus, toimitus tai verkkokaupasta tehty kauppavaraus ja tilaus';
			}
		}
	}

	if (condition === 'webstore') {
		emailRadio.disabled = true;
		phoneRadio.disabled = true;
		emailRadio.checked = true;
		phoneRadio.checked = false;
		emailRadio.parentNode.classList.add('a-radio-group__input--disabled');
		phoneRadio.parentNode.classList.add('a-radio-group__input--disabled');
		if (contactInfoSpan.classList.contains('hidden')) {
			contactInfoSpan.classList.remove('hidden');
		}
	} else {
		emailRadio.disabled = false;
		phoneRadio.disabled = false;
		if (emailRadio.parentNode.classList.contains('a-radio-group__input--disabled')) {
			emailRadio.parentNode.classList.remove('a-radio-group__input--disabled');
		}
		if (phoneRadio.parentNode.classList.contains('a-radio-group__input--disabled')) {
			phoneRadio.parentNode.classList.remove('a-radio-group__input--disabled');
		}
		contactInfoSpan.classList.add('hidden');
	}
}

const checkCategory = () => {
	if (orderNumberInput.classList.contains('hidden')) {
		orderNumberInput.classList.remove('hidden');
	}
	if (categoriesSelect.value === 'a6') {
		orderNumberInput.classList.add('hidden');
	}
}


const hideEmptyOption = () => {
	shopsSelect.options[1].classList.add('hidden');
}


const closeAlert = () => {
	alertDialog.classList.add('hidden');
}

export default function() {
	filterCategories();
	hideEmptyOption();
	checkFormVisibility();

	if (feedbackForm.querySelector('.validation-alert') !== null) {
		showForm();
	}

	hideButton.addEventListener('click', toggleFormVisibility);
	window.addEventListener('resize', checkFormVisibility);
	webstoreRadio.addEventListener('click', filterCategories);
	intersportStoreRadio.addEventListener('click', filterCategories);
	categoriesSelect.addEventListener('change', checkCategory);

	if (closeAlertButton) {
		closeAlertButton.addEventListener('click', closeAlert);
	}

	return () => {
		hideButton.removeEventListener('click', toggleFormVisibility);
		window.removeEventListener('resize', checkFormVisibility);
		webstoreRadio.removeEventListener('click', filterCategories);
		intersportStoreRadio.removeEventListener('click', filterCategories);
		categoriesSelect.removeEventListener('change', checkCategory);

		if (closeAlertButton) {
			closeAlertButton.removeEventListener('click', closeAlert);
		}
	}
}
